import { render, staticRenderFns } from "./RootPage.vue?vue&type=template&id=f665f3da"
import script from "./RootPage.vue?vue&type=script&lang=js"
export * from "./RootPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports